<style lang="scss">
    .GameCreditHezhi1 {
        .balls, .tools {
            width:600px; text-align:left;
            .ball {
                text-align:center;
            }
        }
    }
</style>
<template>
    <div class="GameFormalPlay GameCreditHezhi1">
        <ul v-if="params" class="box">
            <li v-for="(row,unit) in template.sub[0]" class="row l-flex-1">
                <div class="title">
                    <p>{{ row }}</p>
                </div>

                {{/* 选球组 */}}
                <div class="balls">
                    <li v-for="(item,index) in Dir" class="ball" :class="{'active': params[unit] && params[unit][index]}" @click="Pick(unit,index)">
                        <span>{{ item }}</span>
                    </li>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import Common from './hezhi1.js'
export default {
    mixins: [Common],
    components: {

    }
}
</script>
